import { useLobbyParams } from "@shared/hooks/lobby";
import { TLocale } from "@shared/services";

export interface Banner {
  id: number;
  type: "simple" | "text" | "bonus";
  bonusId: null | string;
  backgroundImage: BackgroundImages;
  titles: BannerText[];
  subtitles: BannerText[];
  action: TBannerActions;
  desktopImageExist: undefined | boolean;
  mobileImageExist: undefined | boolean;
}

export type TBannerActions = null | {
  type: "url" | "provider" | "game" | "tag";
  value: "string";
};

interface BackgroundImages {
  desktop: string | null;
  mobile: string | null;
}

interface BannerText {
  lang: TLocale;
  value: string;
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const useBannersItems = (): Banner[] => {
  const lobby = useLobbyParams();

  return lobby?.slider?.banners ?? null;
};
